import { __awaiter, __generator } from "tslib";
import { defineComponent, ref, onMounted, watch } from 'vue';
import BaseLayout from '@/layouts/BaseLayout.vue';
import { ArrowLeftBold } from '@element-plus/icons';
import tourismHandler from '@/api-handler/tourism';
import { useRouter } from 'vue-router';
export default defineComponent({
    name: 'FindScenicFood',
    components: {
        BaseLayout: BaseLayout,
        ArrowLeftBold: ArrowLeftBold,
    },
    setup: function () {
        var _this = this;
        var isShowBikeLand = ref(false);
        var currentPosition = ref(null);
        var searchType = ref('Spot');
        var nearByTourismInfo = ref([]);
        var router = useRouter();
        var getLocation = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!navigator.geolocation) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.geolocation.getCurrentPosition(showPosition)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var showPosition = function (position) {
            var _a = position.coords, latitude = _a.latitude, longitude = _a.longitude;
            currentPosition.value = {
                lat: latitude,
                lng: longitude,
            };
        };
        var getNearByScenics = function (currentPosition) { return __awaiter(_this, void 0, void 0, function () {
            var lat, lng, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lat = currentPosition.lat, lng = currentPosition.lng;
                        return [4 /*yield*/, tourismHandler.getNearbyScenicSpots(lat, lng)];
                    case 1:
                        res = _a.sent();
                        nearByTourismInfo.value = res.data;
                        return [2 /*return*/];
                }
            });
        }); };
        var getNearbyRestaurants = function (currentPosition) { return __awaiter(_this, void 0, void 0, function () {
            var lat, lng, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        lat = currentPosition.lat, lng = currentPosition.lng;
                        return [4 /*yield*/, tourismHandler.getNearbyRestaurants(lat, lng)];
                    case 1:
                        res = _a.sent();
                        nearByTourismInfo.value = res.data;
                        return [2 /*return*/];
                }
            });
        }); };
        var searchTourism = function () {
            if (!currentPosition.value)
                return;
            if (searchType.value === 'Spot') {
                getNearByScenics(currentPosition.value);
            }
            if (searchType.value === 'Food') {
                getNearbyRestaurants(currentPosition.value);
            }
        };
        var getDetail = function (v) {
            var Picture = v.Picture, Phone = v.Phone, Position = v.Position, OpenTime = v.OpenTime, Address = v.Address, Name = v.Name, Description = v.Description;
            var detail = {
                picture: Picture.PictureUrl1 ? Picture.PictureUrl1 : '../assets/no-image-found.png',
                phone: Phone,
                positionLat: Position.PositionLat,
                positionLng: Position.PositionLon,
                openTime: OpenTime,
                address: Address,
                name: Name,
                description: Description
            };
            router.push({ name: 'ScenicFoodInfoDetail', params: detail });
        };
        var goBack = function () {
            router.back();
        };
        watch(function () { return currentPosition.value; }, function () {
            searchTourism();
        });
        watch(function () { return searchType.value; }, function () {
            searchTourism();
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getLocation()];
                    case 1:
                        _a.sent();
                        if (currentPosition.value) {
                            getNearByScenics(currentPosition.value);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        return {
            searchType: searchType,
            nearByTourismInfo: nearByTourismInfo,
            getLocation: getLocation,
            getDetail: getDetail,
            goBack: goBack,
        };
    },
});
